import { isFeatureApp, isContentContainerWithContent, } from '../content-types';
export function isContainerError(item) {
    return item instanceof Error;
}
export function getLoadableContentPaths(items, currentState) {
    return Array.from(new Set(items
        .filter((item) => {
        if (typeof item === 'string') {
            return needsLoading(item, currentState);
        }
        if (isFeatureApp(item) || isContentContainerWithContent(item)) {
            return false;
        }
        return needsLoading(item.contentPath, currentState);
    })
        .map((item) => (typeof item === 'string' ? item : item.contentPath))));
}
function needsLoading(contentPath, currentState) {
    const state = currentState[contentPath];
    return isContainerError(state) || state === undefined;
}
export function concatenate(index, __depth, instance) {
    if (typeof __depth === 'undefined') {
        return `${index + 1}`;
    }
    let result = '';
    if (instance) {
        result += `${instance}-`;
    }
    if (__depth !== '') {
        result += `${__depth}-`;
    }
    result += `${index + 1}`;
    return result;
}
//# sourceMappingURL=utils.js.map